module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedLight.8e2e842.ttf";